import { UseMutationOptionsFromProvider, useMutationEndpoint } from '../../core'
import { putAccessManagementAccount } from '../endpoints'

type EndpointParams = Parameters<typeof putAccessManagementAccount>[0]
type HookParams = Pick<EndpointParams, 'apiVersion'>
type MutationVariables = Pick<EndpointParams, 'data'>

export const useAccessManagementAccountPutMutation = (
  { apiVersion }: HookParams,
  options?: UseMutationOptionsFromProvider<
    typeof putAccessManagementAccount,
    MutationVariables
  >,
) =>
  useMutationEndpoint(
    ({ data }: MutationVariables) =>
      putAccessManagementAccount({ apiVersion, data }),
    options,
  )
